// extracted by mini-css-extract-plugin
module.exports = {"container":"Textarea_container__3c9k2","label":"Textarea_label__2aIQ5","textarea":"Textarea_textarea__31mWi"};